import { ComponentType } from "react";
import useDynamicData from "../../hooks/useDynamicData";
import filterChildren from "../../hooks/filterChildren";

interface HookWrapperProps {
    component: ComponentType<any>;
    [key: string]: any;
    fromBuilder?: boolean;
    builderProps?: any;
}

const HookWrapper = (props: HookWrapperProps) => {
    const { component: Component, dataObject, dynamicDataSet, t, hubDynamicData, formatCurrency, formatAmount, ...rest } = props;

    const newString = useDynamicData({
        dynamicDataString: props.node.dynamicData,
        customEntity: dataObject,
        fromBuilder: props.fromBuilder,
        fallback: props.node?.fallback?.value || props.node?.image?.urlFallback,
        timeFormat: props.node?.timeFormat,
        hubDynamicData: hubDynamicData,
        formatCurrency: formatCurrency,
        formatAmount: formatAmount
    });

    // best solution for now - consider refactoring in the future
    // in the future change this when we have data contexts ("Sections")
    // let caseSpecificProps = {};
    // if (props.node.name === "orderData" && dataObject) {
    //     caseSpecificProps = { order: dataObject };
    // }

    const childrenToShow = filterChildren({
        children: props.children,
        childrenFilterKey: props.node?.childrenFilterKey,
        dataObject: dataObject || dynamicDataSet,
        previewChildIndex: props?.node?.previewChildIndex,
        isBuilder: !!props.builderProps
    });

    return (
        <Component
            {...rest}
            formatCurrency={formatCurrency}
            formatAmount={formatAmount}
            onClick={props.onClick}
            node={props.node}
            children={childrenToShow}
            dynamicData={t ? t(newString.dynamicData) : newString.dynamicData}
            dynamicDataSet={dynamicDataSet}
            // {...caseSpecificProps}
        />
    );
};

export default HookWrapper;
